"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDropZoneStyle = exports.DataUploadType = void 0;
var DataUploadType;
(function (DataUploadType) {
    DataUploadType["FILE_UPLOAD"] = "FILE_UPLOAD";
    DataUploadType["COLUMN_MAPPING"] = "COLUMN_MAPPING";
})(DataUploadType = exports.DataUploadType || (exports.DataUploadType = {}));
var FileDropZoneStyle;
(function (FileDropZoneStyle) {
    FileDropZoneStyle[FileDropZoneStyle["PRIMARY"] = 0] = "PRIMARY";
    FileDropZoneStyle[FileDropZoneStyle["SECONDARY"] = 1] = "SECONDARY";
})(FileDropZoneStyle = exports.FileDropZoneStyle || (exports.FileDropZoneStyle = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZGF0YS11cGxvYWQvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksY0FHWDtBQUhELFdBQVksY0FBYztJQUN4Qiw2Q0FBMkIsQ0FBQTtJQUMzQixtREFBaUMsQ0FBQTtBQUNuQyxDQUFDLEVBSFcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFHekI7QUFFRCxJQUFZLGlCQUdYO0FBSEQsV0FBWSxpQkFBaUI7SUFDM0IsK0RBQU8sQ0FBQTtJQUNQLG1FQUFTLENBQUE7QUFDWCxDQUFDLEVBSFcsaUJBQWlCLEdBQWpCLHlCQUFpQixLQUFqQix5QkFBaUIsUUFHNUIifQ==